import { Button, Card, Stack, useTheme } from '@fti/design-system';
import { StaticReflectionView } from '../reflections/StaticReflectionView';
import { PublicationNotesEditor } from './PublicationNotesEditor';
import type { Publication } from '../../../types/media-sim';

interface PublicationDetailPanelProps {
  publication: Publication;
  isAdmin: boolean;
  onClose: () => void;
  onSaved?: () => void;
}

export function PublicationDetailPanel({
  publication,
  isAdmin,
  onClose,
  onSaved,
}: PublicationDetailPanelProps) {
  const { theme } = useTheme();

  return (
    <Card variant="elevated">
      <Card.Header
        title={publication.publisher}
        subtitle={`Milvus collection: ${publication.milvus_id}`}
        action={
          <Button variant="ghost" color="neutral" size="sm" onClick={onClose}>
            Close
          </Button>
        }
      />
      <Card.Body>
        <Stack gap="lg">
          {/* Static Reflection Notes */}
          <StaticReflectionView
            publicationId={publication.id}
            isAdmin={isAdmin}
          />

          {/* Publication Notes */}
          <PublicationNotesEditor
            publication={publication}
            isAdmin={isAdmin}
            onSaved={onSaved}
          />
        </Stack>
      </Card.Body>
    </Card>
  );
}
